import { render } from "./EmailLanding.vue?vue&type=template&id=77744f98&scoped=true"
import script from "./EmailLanding.vue?vue&type=script&lang=js"
export * from "./EmailLanding.vue?vue&type=script&lang=js"

import "./EmailLanding.vue?vue&type=style&index=0&id=77744f98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77744f98"]])

export default __exports__